/** Valores persistidos en BD / aceptados por API (formato legacy). */
export const COND_IVA_INSCRIPTO_VALUE = 'RESP. INSCRIPTO';
export const COND_IVA_MONOTRIBUTO_VALUE = 'RESP. MONOTRIBUTO';

/** Valores permitidos de condición IVA para compañías (texto impreso en comprobantes y reportes). */
export const COND_IVA_COMPANIA_OPCIONES: { value: string; label: string }[] = [
  { value: COND_IVA_INSCRIPTO_VALUE, label: 'Responsable Inscripto' },
  { value: COND_IVA_MONOTRIBUTO_VALUE, label: 'Responsable Monotributo' },
  { value: 'Sujeto Exento', label: 'Sujeto Exento' },
  { value: 'Consumidor Final', label: 'Consumidor Final' },
  { value: 'No Categorizado', label: 'No Categorizado' },
];

export const COND_IVA_COMPANIA_VALUES = new Set(
  COND_IVA_COMPANIA_OPCIONES.map((o) => o.value.toUpperCase()),
);

function normCondIvaTexto(condIva: string): string {
  return condIva
    .toUpperCase()
    .replace(/\./g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Mapea variantes guardadas al valor canónico del selector. */
export function normalizarCondIvaCompania(condIva?: string | null): string {
  const raw = (condIva ?? '').trim();
  if (!raw) return '';

  const norm = normCondIvaTexto(raw);

  if (norm === 'RESP MONOTRIBUTO' || norm.includes('MONOTRIBUTO')) {
    return COND_IVA_MONOTRIBUTO_VALUE;
  }

  if (
    norm === 'RESP INSCRIPTO'
    || norm === 'IVA RESPONSABLE INSCRIPTO'
    || (norm.includes('INSCRIPTO') && norm.includes('RESP'))
    || norm.includes('RESPONSABLE INSCRIPTO')
  ) {
    return COND_IVA_INSCRIPTO_VALUE;
  }

  const exact = COND_IVA_COMPANIA_OPCIONES.find(
    (o) => o.value.toUpperCase() === raw.toUpperCase(),
  );
  return exact?.value ?? raw;
}

/** True si el emisor es Responsable Monotributo (no discrimina IVA en ventas). */
export function esCondIvaMonotributo(condIva?: string | null): boolean {
  return normalizarCondIvaCompania(condIva) === COND_IVA_MONOTRIBUTO_VALUE;
}
